import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Database,
  Settings,
  LogOut,
} from "lucide-react";
import "./sidebar.css";

export default function Sidebar({ isOpen = true, onLogout }) {
  return (
    <aside className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      {/* HEADER */}
      <div className="sidebar-header">
        <h2 className="sidebar-title">MetroUni</h2>
        {isOpen && (
          <span className="sidebar-subtitle">
            Admin Management Panel
          </span>
        )}
      </div>

      {/* NAV */}
      <nav className="sidebar-nav">
        <NavLink to="/" className="nav-item">
          <LayoutDashboard size={18} />
          {isOpen && <span>Dashboard</span>}
        </NavLink>

        <NavLink to="/user-management" className="nav-item">
          <Users size={18} />
          {isOpen && <span>User Management</span>}
        </NavLink>

        <NavLink to="/settings" className="nav-item">
          <Settings size={18} />
          {isOpen && <span>Settings</span>}
        </NavLink>
      </nav>

      {/* FOOTER */}
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={onLogout}>
          <LogOut size={18} />
          {isOpen && <span>Logout</span>}
        </button>
      </div>
    </aside>
  );
}
